import './css/dashboardtable.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';
import Landing from '../Landing';




function AllBlogs(){


        
    useEffect(() => {
        axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){

            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);



    
    const navigate = useNavigate();
    const [AllBlogs, setAllBlogs] = useState([]);

    axios.defaults.withCredentials = true;





    const getAllBlogs = ()=>{
        axios.post('AllItems', {
            table: 'blogs',
        })
        .then((res) => {
            if (res.data) {
                console.log(res.data)
                setAllBlogs(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    







    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            console.log(res.data.valid);
            navigate('/admin-login');

        }else{
            console.log(res.data.valid);

        }
    })
    .catch((err) => console.log(err));

    }





    const deleteItem = (id) => {
        axios
        .delete(`delete-item/${id}`, {
            data: {
            table: 'blogs',
            },
        })
        .then((response) => {
            if (response.data.message === 'Item deleted successfully') {
                getAllBlogs();
            } else {
            console.error('Failed to delete result:', response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error deleting result:', error);
        });
    };




useEffect(() => {

    getAllBlogs();
    getIfLogin();

}, []);




    

    return(
        <>
            <section className='dashboard'>



                <div className='results-table'>
                <Link className='new-item' to='/add-blog'> +  Add New Blog </Link>
                <table>

                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>IMG</th>
                            <th> Header </th>
                            <th>Options</th>

                        </tr>
                    </thead>
                    <tbody>
                    {AllBlogs.length ? (

                        AllBlogs.map(blog => {

                        return (
                            <tr key={blog.id}>
                            <td><h6>{blog.id}</h6></td>

                            <td><img src={`/uploads/${blog.img}`} alt="User avatar"/></td>
                            <td><h6>{blog.header}</h6></td>

                            <td>
                                <Link className='edit' to={`/edit-blog?id=${blog.id}`}> <i class="las la-edit"></i> </Link>
                            </td>

                            
                            <td>
                                <button className='delete' onClick={() => deleteItem(blog.id)}> <i class="las la-trash-alt"></i> </button>
                            </td>

                            </tr>
                        );
                        })): 
                        
                        
                        
                        (
                            <tr>
                                <td colSpan={5}>Loading...</td>
                            </tr>
                            )}
                    </tbody>
                </table>

                </div>
            </section>
        
        </>
    )
}

export default AllBlogs;